import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@headlessui/react';
import cn from 'classnames';

function SwitchToggle({
  onChange,
  value,
  containerClassName,
  label,
  labelClassName,
  disabled,
}) {
  return (
    <Switch.Group>
      <div className={cn(containerClassName, 'flex items-center gap-2')}>
        <Switch
          checked={value}
          onChange={onChange}
          disabled={disabled}
          className={cn(
            'relative inline-flex flex-shrink-0 h-[22px] w-10 p-[3px] rounded-full transition-colors ease-in-out duration-200',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 focus-visible:ring-offset-2',
            // eslint-disable-next-line no-nested-ternary
            disabled
              ? 'bg-neutral-200 cursor-not-allowed'
              : value
              ? 'bg-brand-600 cursor-pointer'
              : 'bg-neutral-400 cursor-pointer',
          )}
        >
          <span className="sr-only">{label || 'Toggle'}</span>
          <span
            aria-hidden="true"
            className={cn(
              value ? 'translate-x-[18px]' : 'translate-x-0',
              'pointer-events-none inline-block h-4 w-4 rounded-full transform ring-0 transition ease-in-out duration-200',
              disabled ? 'bg-neutral-50' : 'bg-white',
            )}
          />
        </Switch>
        {label && (
          <Switch.Label
            className={cn(
              'text-sm font-medium text-neutral-700',
              labelClassName,
            )}
          >
            {label}
          </Switch.Label>
        )}
      </div>
    </Switch.Group>
  );
}

SwitchToggle.defaultProps = {
  disabled: false,
  label: '',
  containerClassName: '',
  labelClassName: '',
  onChange: () => {},
};

SwitchToggle.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
};

export default SwitchToggle;
